module.exports = __webpack_public_path__ + "static/media/kgp-slide-8.f35e9fcb.jpg";